import { ApiMethod } from 'services/api';
import { useRestMutation, UseRestMutationOptions } from 'utils/hooks/api/useRestMutation';
import { Goal, GoalAttributionMode } from 'modules/goals/types';

export const CREATE_GOAL_API_URL = '/i/goals';

export type CreateGoalMutationResponse = Goal;

export type CreateGoalMutationBody = {
  name: string;
  eventName: string;
  eventType: string;
  attributionMode: GoalAttributionMode;
  attributionWindowHours?: number;
  campaignLabelIds: number[];
  messageTypeIds: number[];
};

export const useCreateGoalMutation = (
  options: UseRestMutationOptions<CreateGoalMutationResponse>,
) => {
  return useRestMutation<CreateGoalMutationResponse, CreateGoalMutationBody>(
    CREATE_GOAL_API_URL,
    ApiMethod.post,
    options,
  );
};
